export interface AnimateTranslationOptions {
  cellElement: HTMLElement;
  translatedText: string;
  onComplete?: () => void;
}

export const animateTranslation = async ({ cellElement, translatedText, onComplete }: AnimateTranslationOptions) => {
  // Split by spaces but preserve spaces in the output
  const words = translatedText.split(/\s+/);
  const animatedHTML = words.map((word: string, index: number) => {
    // Calculate staggered delay based on word position
    const delay = 0.08 * index;
    // Make animation more dramatic for longer words
    const distance = Math.min(10 + word.length, 20);
    
    return `<span 
      class="word-animate" 
      style="
        animation-delay: ${delay}s; 
        animation-duration: 0.6s;
        display: inline-block; 
        opacity: 0; 
        transform: translateY(${distance}px);
        animation: fadeInUp 0.6s cubic-bezier(0.2, 0.8, 0.2, 1) ${delay}s forwards;
        position: relative;
      "
    >${word}</span>`;
  }).join(' ');

  // Apply animated HTML immediately
  if (cellElement.getAttribute('contenteditable') === 'true') {
    cellElement.innerHTML = animatedHTML;
  } else {
    // For non-contenteditable elements, find and update child elements
    const cellContent = cellElement.querySelector('.cell-content');
    if (cellContent) {
      cellContent.innerHTML = animatedHTML;
    }
  }

  // Calculate animation duration based on word count, capped at 3.5 seconds
  const animationDuration = Math.min(words.length * 50 + 1500, 3500);

  // Wait for animation to complete
  await new Promise(resolve => setTimeout(resolve, animationDuration));

  // Update with plain text after animation finishes
  if (cellElement.getAttribute('contenteditable') === 'true') {
    cellElement.textContent = translatedText;
  } else {
    const cellContent = cellElement.querySelector('.cell-content');
    if (cellContent) {
      cellContent.textContent = translatedText;
    }
  }

  // Call completion callback if provided
  onComplete?.();
}; 